// extracted by mini-css-extract-plugin
export default {"root":"ScheduledClassesVisibility_root__0Lshs","title":"ScheduledClassesVisibility_title__K0D-n"};